var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFloorBlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 158,
    viewBox: "0 0 169 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 108.266V44.8906L85.8203 93.7422L169 44.8906V108.266L85.8203 157.117L0 108.266Z",
    fill: "#FFA621"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 108.266V44.8906L85.8203 93.7422V157.117L0 108.266Z",
    fill: "#ED8E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 0L0 44.8906L85.8203 95.0625L169 44.8906L84.5 0Z",
    fill: "#FFC774"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.985 124.109V110.906L113.548 105.625V118.828L102.985 124.109Z",
    fill: "#FFE3BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6562 124.109V110.906L58.0938 105.625V118.828L68.6562 124.109Z",
    fill: "#FFE3BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.828 113.547V100.344L129.391 95.0625V108.266L118.828 113.547Z",
    fill: "#FFE3BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8125 113.547V100.344L42.25 95.0625V108.266L52.8125 113.547Z",
    fill: "#FFE3BA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.671 102.984V89.7812L145.233 84.5V97.7031L134.671 102.984Z",
    fill: "#FFE3BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9678 102.984V89.7812L26.4053 84.5V97.7031L36.9678 102.984Z",
    fill: "#FFE3BA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.516 92.4219V79.2188L161.078 73.9375V87.1406L150.516 92.4219Z",
    fill: "#FFE3BA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 92.4219V79.2188L10.5625 73.9375V87.1406L21.125 92.4219Z",
    fill: "#FFE3BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorBlock);
export default __webpack_public_path__ + "static/media/floor_block.c636b246a4d991f91df31e265da395ca.svg";
export { ForwardRef as ReactComponent };